import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AnimatedLogo from './AnimatedLogo';
import DesktopNav from './navbar/DesktopNav';
import MobileMenuToggle from './navbar/MobileMenuToggle';
import MobileDropdown from './navbar/MobileDropdown';
import { NAV_INITIAL, NAV_ANIMATE } from './navbar/navbarConfig';
import { useScrolled } from '../hooks/useScrolled';
import { useSectionNavigator } from '../hooks/useSectionNavigator';

const MENU_COLLAPSE_MS = 350;

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isScrolled = useScrolled(50);

  const goToSection = useSectionNavigator();

  const scrollToSection = (id) => {
    if (isMobileMenuOpen) setIsMobileMenuOpen(false);
    goToSection(id, isMobileMenuOpen ? MENU_COLLAPSE_MS : 0);
  };

  return (
    <motion.nav
      initial={NAV_INITIAL}
      animate={NAV_ANIMATE}
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between h-24 md:h-32 pb-3">
          {/* Premium Animated Logo */}
          <div onClick={() => scrollToSection('home')} data-testid="navbar-logo">
            <AnimatedLogo />
          </div>

          <DesktopNav onNavigate={scrollToSection} />
          <MobileMenuToggle
            isOpen={isMobileMenuOpen}
            onToggle={() => setIsMobileMenuOpen((prev) => !prev)}
          />
        </div>
      </div>

      {/* Mobile dropdown sits OUTSIDE the flex row so it can span full width below the header */}
      <MobileDropdown isOpen={isMobileMenuOpen} onNavigate={scrollToSection} />
    </motion.nav>
  );
};

export default Navbar;
